"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTable = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const react_bootstrap_table2_paginator_1 = __importDefault(require("react-bootstrap-table2-paginator"));
const react_i18next_1 = require("react-i18next");
const overlayElementFunction_1 = __importDefault(require("./overlayElementFunction"));
exports.DataTable = ({ initialSizePerPage, rowClasses, keyField, hover, bordered, striped, data, columns, onClick, totalSize, loading, defaultSorted, onChangeLoopback, overlayElement, query, context, noDataText, }) => {
    const [page, setPage] = react_1.useState(1);
    const [sizePerPage, setSizePerPage] = react_1.useState(20);
    const { t } = react_i18next_1.useTranslation(context || 'DataTable');
    const onTableChange = (_, object) => {
        if (onChangeLoopback) {
            let field = defaultSorted.dataField;
            let { order } = defaultSorted;
            if (object.sortField && object.sortOrder) {
                field = object.sortField;
                order = object.sortOrder;
            }
            onChangeLoopback(Object.assign(Object.assign({}, query), { order: `${field} ${order}`, limit: object.sizePerPage, skip: (object.page - 1) * object.sizePerPage }));
        }
        setSizePerPage(object.sizePerPage);
        setPage(object.page);
    };
    react_1.useEffect(() => {
        setSizePerPage(initialSizePerPage || 20);
        const object = {
            page,
            sizePerPage,
            sortField: '',
            sortOrder: '',
        };
        onTableChange('componentDidMount', object);
        // eslint-disable-next-line
    }, [initialSizePerPage]);
    const getCombinedRowClasses = () => {
        const combinedRowClasses = [];
        if (rowClasses)
            combinedRowClasses.push(rowClasses);
        if (onClick)
            combinedRowClasses.push('BootstrapTable-hover');
        return combinedRowClasses;
    };
    let rowEvents;
    const combinedRowClasses = getCombinedRowClasses();
    if (onClick)
        rowEvents = { onClick };
    return (react_1.default.createElement(react_bootstrap_table_next_1.default, { bootstrap4: true, remote: true, classes: "table-responsive-sm", keyField: keyField || 'id', hover: hover || true, bordered: bordered || false, striped: striped || true, onTableChange: onTableChange, noDataIndication: () => (react_1.default.createElement("p", { style: { textAlign: 'center', margin: 0 } }, noDataText || t('noDataText'))), loading: loading || false, overlay: overlayElementFunction_1.default({
            overlayElement,
            loadingText: t('loadingText'),
        }), rowClasses: combinedRowClasses.join(' '), data: data, rowEvents: rowEvents, pagination: react_bootstrap_table2_paginator_1.default({ page, sizePerPage, totalSize }), columns: columns }));
};
//# sourceMappingURL=DataTable.js.map